<template>
    <v-col cols="12" md="6" lg="6">
      <v-row>
        <v-col cols="12" lg="5" md="6" sm="4">
          <global-MultipleSelect 
            ref="stallHoldersRef" 
            :label="labelStallHolders" 
            :dataList="allStallHoldersList" 
            :itemText="StallHolderName" 
            :itemValue="StallHolderId" 
            @checkSelectedList="handleSelectedList">
          </global-MultipleSelect>
        </v-col>
        <v-col cols="12" lg="5" md="6" sm="4">
          <global-MultipleSelect 
            ref="stallRef" 
            :label="labelStall" 
            :dataList="stalls" 
            :itemText="StallName" 
            :itemValue="StallId" 
            :isDisable="isDisableStall"
            @checkSelectedList="handleSelectedListTerminal">
          </global-MultipleSelect>
        </v-col>
        </v-row>
        <v-row class="mt-n9">
        <v-col v-if="showTerminals" cols="12" lg="5" md="6" sm="6">
          <global-MultipleSelect 
            ref="terminalNumberRef" 
            :label="labelTerminalNumber" 
            :dataList="terminal" 
            :itemText="terminalName" 
            :itemValue="terminalId" 
            :isDisable="isDisableTerminals"
            @checkSelectedList="handleSelectedListTerminals">
          </global-MultipleSelect>
        </v-col>
      </v-row>
    </v-col>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'StallholderFilterGroup',
  props: {
    showTerminals: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('filter', [
      'globalEventFilter',
      'searchStallholders',
      'searchStalls',
      'searchTerminals'
    ]),
    allStallHoldersList() {
      return this.globalEventFilter?.Stallholders || [];
    },
    isDisableTerminals() {
      return this.terminal.length === 0;
    },
    isDisableStall() {
      return this.stalls.length === 0;
    }
  },
  data() {
    return {
      labelStallHolders: 'Stallholders',
      StallHolderName: 'StallholderName',
      StallHolderId: 'StallholderId',
      labelStall: 'Stall',
      StallName: 'StallName',
      StallId: 'StallId',
      labelTerminalNumber: 'Terminal Number',
      terminalName: 'TerminalNumber',
      terminalId: 'TermId',
      stalls: [],
      terminal: []
    };
  },
  watch: {
    'globalEventFilter.EventId'(newVal) {
      if (newVal) {
        this.$emit('event-changed');
      }
    },
    stalls: {
      handler(newStalls) {
        // Initialize stalls selection when stalls array is populated
        if (this.searchStalls && this.searchStalls !== 'notSet' && newStalls.length > 0) {
          const selectedStalls = newStalls.filter(
            s => this.searchStalls.includes(s.StallId)
          );
          if (selectedStalls.length > 0) {
            this.$nextTick(() => {
              this.$refs.stallRef.selectedList = selectedStalls;
              this.handleSelectedListTerminal(selectedStalls, false);
            });
          }
        }
      },
      immediate: true
    },
    terminal: {
      handler(newTerminals) {
        // Initialize terminals selection when terminals array is populated
        if (this.showTerminals && this.searchTerminals && 
            this.searchTerminals !== 'notSet' && newTerminals.length > 0) {
          const selectedTerminals = newTerminals.filter(
            t => this.searchTerminals.includes(t.TermId)
          );
          if (selectedTerminals.length > 0) {
            this.$nextTick(() => {
              this.$refs.terminalNumberRef.selectedList = selectedTerminals;
              this.handleSelectedListTerminals(selectedTerminals);
            });
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.initializeSelections();
  },
  methods: {
    ...mapMutations('filter', {
      setSearchStallholders: 'setSearchStallholders',
      setSearchStalls: 'setSearchStalls',
      setSearchTerminals: 'setSearchTerminals'
    }),

    initializeSelections() {
      // Initialize stallholders from Vuex state if values exist
      if (this.searchStallholders && 
          this.searchStallholders !== 'notSet' && 
          this.globalEventFilter?.Stallholders) {
        const selectedStallholders = this.globalEventFilter.Stallholders.filter(
          sh => this.searchStallholders.includes(sh.StallholderId)
        );
        if (selectedStallholders.length > 0) {
          this.$nextTick(() => {
            this.$refs.stallHoldersRef.selectedList = selectedStallholders;
            this.handleSelectedList(selectedStallholders, false);
          });
        }
      }
    },

    handleSelectedList(value, shouldResetDependents = true) {
      // Update stalls array for UI
      this.stalls = [];
      if (value.length > 0) {
        value.forEach((obj) => {
          obj.Stalls.forEach((data) => {
            this.stalls.push(data);
          });
        });
      }

      // Update Vuex state
      const stallholderIds = value.map(r => r.StallholderId);
      this.setSearchStallholders(stallholderIds.length > 0 ? stallholderIds : 'notSet');
      
      // Always clear dependent selections if stallholders are cleared
      if (stallholderIds.length === 0 || shouldResetDependents) {
        this.setSearchStalls('notSet');
        this.setSearchTerminals('notSet');
        this.terminal = [];
        
        // Clear UI selections
        if (this.$refs.stallRef) {
          this.$refs.stallRef.selectedList = [];
        }
        if (this.showTerminals && this.$refs.terminalNumberRef) {
          this.$refs.terminalNumberRef.selectedList = [];
        }
      }
    },

    handleSelectedListTerminal(value, shouldResetDependents = true) {
      // Update terminals array for UI
      if (this.showTerminals) {
        this.terminal = [];
        if (value.length > 0) {
          value.forEach((obj) => {
            if (obj.Terminals) {
              obj.Terminals.forEach((data) => {
                this.terminal.push(data);
              });
            }
          });
        }
      }

      // Update Vuex state
      const stallIds = value.map(r => r.StallId);
      this.setSearchStalls(stallIds.length > 0 ? stallIds : 'notSet');
      
      // Always clear terminals if stalls are cleared
      if (stallIds.length === 0 || (shouldResetDependents && this.showTerminals)) {
        this.setSearchTerminals('notSet');
        
        // Clear UI selection
        if (this.$refs.terminalNumberRef) {
          this.$refs.terminalNumberRef.selectedList = [];
        }
      }
    },

    handleSelectedListTerminals(value) {
      if (!this.showTerminals) return;
      
      // Update Vuex state
      const terminalIds = value.map(r => r.TermId);
      this.setSearchTerminals(terminalIds.length > 0 ? terminalIds : 'notSet');
      
      // Emit that filters have been updated
      this.$emit('filters-updated');
    }
  }
};
</script> 